import { type IconContainerProps } from '@utilitywarehouse/hearth-react';
import { type ReactNode, type RefObject } from 'react';

import { type CashbackCalculatorRetailers } from '@generated/gql/graphql';

import { SpendBrandFields } from './SpendBrand/types';
import { type CategoryFields } from './SpendCategory/types';

interface Outputs {
  category: CalculationOutput;
  brand: CalculationOutput;
}

export interface CashbackCalculatorContextState {
  output: Outputs;
  setOutput: (type: SpendType, output: CalculationOutput) => void;
  currentSpendCalc: SpendType;
  setCurrentSpendCalc: (type: SpendType) => void;
  currentEarnTab: EarnType;
  setCurrentEarnTab: (type: EarnType) => void;
  retailers: CashbackCalculatorRetailers;
  retailersLoading: boolean;
  coreServiceCount: number;
  initialFormValues: CalculatorFields;
  useCashbackValueInComms: boolean;
  setUseCashbackValueInComms: (value: boolean) => void;
  saveForm: (values: CalculatorFields) => void;
  submitForm: () => void;
  formRef: RefObject<Nullable<HTMLFormElement>>;
}

export interface Category {
  id: keyof CategoryFields;
  name: string;
  color: IconContainerProps['colorScheme'];
  icon: ReactNode;
  max: number;
}

export enum PanelType {
  Spend = 'spend',
  Earn = 'earn',
}

export enum SpendType {
  Category = 'category',
  Brand = 'brand',
}

export enum EarnType {
  OverTime = 'over-time',
  Category = 'category',
}

export interface CalculationOutputCategory {
  category: string;
  spend: number;
  earnings: number;
  /**
   * string array of retailer IDs
   */
  retailers: string[];
}

interface CalculationTotal {
  spend: number;
  earnings: number;
}

export interface CalculationOutput {
  categories: CalculationOutputCategory[];
  total: CalculationTotal;
}

export type CalculatorFields = SpendBrandFields | CategoryFields;
